import { useOpgavekompleksetComponent } from '../../../state/context.data.js';
import { getProgressionType } from '../../../state/util.get-progression-type.js';
import { ConditionalProgressionActions } from './integration.conditional-progression.js';
import { FixedProgressionActions } from './integration.fixed-progression.js';
import { FreeProgressionActions } from './integration.free-progression.js';
import { jsx } from 'react/jsx-runtime';

function TaskActions(props) {
  const component = useOpgavekompleksetComponent();
  const content = (() => {
    if (component.data.settings.flowType === "conditional") {
      return /*#__PURE__*/jsx(ConditionalProgressionActions, {});
    }
    switch (getProgressionType(component.data.settings.flowType)) {
      case "fixed":
        return /*#__PURE__*/jsx(FixedProgressionActions, {});
      case "free":
        return /*#__PURE__*/jsx(FreeProgressionActions, {});
    }
  })();
  return /*#__PURE__*/jsx("div", {
    className: props.className,
    children: content
  });
}

export { TaskActions };
//# sourceMappingURL=_actions.js.map
